import { useEffect, useState } from 'react';
import { Card, CardContent, CircularProgress, Grid, Link, Typography } from '@mui/material';
import LockIcon from '@mui/icons-material/Lock';
import { CustomerQuery } from '../../../../../services/query';
import Swal from 'sweetalert2';
import { useTranslation } from 'react-i18next';
import LinkIcon from '@mui/icons-material/Link';
import { IconInfo } from '../../../../../assets/icons/svg/icons';
import Helper from '../../../../../utils/helper';
import PersonIcon from '@mui/icons-material/Person';
import { CIC, uodCls } from '../userOrderDetails.classes';

const cardSx = {
    height: '180px',
    paddingTop: '2rem',
};

const lockIconSx = {
    fontSize: 40,
    color: 'blue',
};

function CustomerInformationCard({ customerId }: any) {
    const [data, setData] = useState<any>();
    const [loading, setLoading] = useState<any>(true);
    const [isBlackListCustomer, setIsBlackListCustomer] = useState(false);

    const { t } = useTranslation();

    useEffect(() => {
        CustomerQuery.GetCustomerById(customerId)
            .then((res: any) => {
                setData(res.data.customer);
                setLoading(false);
            })
            .catch((error) => {
                switch (error.status) {
                    case 401:
                        Swal.fire('401', '', 'error');
                        break;
                    case 403:
                        Swal.fire('403', '', 'error');
                        break;
                    case 404:
                        Swal.fire('404', '', 'error');
                        break;
                    case 500:
                        Swal.fire('500', '', 'error');
                        break;
                }
            });
        CustomerQuery.GetCustomerRiskStatusByCustomerId(customerId).then((res: any) => {
            if (res.data) {
                if (res.data.isCusromerRisky) {
                    setIsBlackListCustomer(res.data.isCusromerRisky);
                }
            }
        });
    }, []);

    return loading ? (
        <Grid
            className={CIC.loadingGrid}
            container
            style={{ height: '100%' }}
            alignItems="center"
            justifyContent="center"
        >
            <div
                className={CIC.loadingInner}
                style={{
                    textAlign: 'center',
                    position: 'relative',
                    pointerEvents: 'none',
                }}
            >
                <CircularProgress size={80} />
            </div>
        </Grid>
    ) : (
        <>
            <Grid
                sx={{ boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.1)' }}
                className={uodCls('userInfos', CIC.root)}
                size={{
                    xs: 12,
                    sm: 12,
                    md: 12,
                }}
            >
                <Card className={CIC.headerCard} sx={{ padding: '1rem' }}>
                    <div className={uodCls('sideBySideDiv', CIC.headerTitleRow)}>
                        {' '}
                        <PersonIcon className={CIC.headerIcon} style={{ marginTop: '0.6rem' }} />{' '}
                        <h3 className={CIC.title} style={{ marginLeft: '0.5rem' }}>
                            <strong> {t('orderDetail.userInfos')}</strong>
                        </h3>
                        {isBlackListCustomer && !Helper.isStoreEmployeeForFrontend() && (
                            <img
                                className={CIC.blacklistInfoTrigger}
                                width={20}
                                style={{ marginLeft: '1rem' }}
                                src={IconInfo}
                                alt=""
                                onClick={() => Swal.fire('Bu müşteri kara listededir', ' ', 'error')}
                            />
                        )}
                    </div>
                </Card>
                <div className={CIC.divider} style={{ height: '2px', background: 'lightGray' }}></div>
                <Card className={CIC.bodyCard} sx={cardSx}>
                    <CardContent className={CIC.bodyContent}>
                        {data ? (
                            <>
                                <Typography className={CIC.nameRow} variant="body2">
                                    {t('orderDetail.nameSurname')} {data.firstName + ' '} {data.lastName}
                                </Typography>
                                <Typography className={CIC.phoneRow} variant="body2">
                                    {t('orderDetail.phone')} {data.phoneNumber}
                                </Typography>
                                <div
                                    className={CIC.emailRow}
                                    style={{
                                        display: 'flex',
                                        gap: '1rem',
                                        cursor: 'pointer',
                                        flexWrap: 'wrap',
                                    }}
                                >
                                    <Typography className={CIC.emailText} variant="body2">
                                        {t('orderDetail.email')} {data.email}
                                    </Typography>
                                    <Link
                                        className={uodCls('customerLink', CIC.linkCustomerManagement)}
                                        target={'_blank'}
                                        href={'/customerManagement/?customerId=' + data.customerId}
                                    >
                                        <LinkIcon></LinkIcon>
                                    </Link>
                                </div>
                            </>
                        ) : (
                            <Grid
                                className={CIC.lockedGrid}
                                container
                                style={{ height: '100%' }}
                                alignItems="center"
                                justifyContent="center"
                            >
                                <div
                                    className={CIC.lockedInner}
                                    style={{
                                        textAlign: 'center',
                                        position: 'relative',
                                        pointerEvents: 'none',
                                    }}
                                >
                                    <LockIcon
                                        className={CIC.lockedIcon}
                                        sx={{
                                            ...lockIconSx,
                                            position: 'absolute',
                                            top: '50%',
                                            left: '50%',
                                            transform: 'translate(-50%, -50%)',
                                            pointerEvents: 'none',
                                        }}
                                    />
                                    <div
                                        className={CIC.lockedBlurContent}
                                        style={{
                                            filter: 'blur(5px)',
                                            color: 'gray',
                                            userSelect: 'none',
                                        }}
                                    >
                                        <Typography variant="body2" style={{ userSelect: 'none' }}>
                                            {t('orderDetail.nameSurname')} Test
                                        </Typography>
                                        <Typography variant="body2" style={{ userSelect: 'none' }}>
                                            {t('orderDetail.phone')} 0555 555 55 55
                                        </Typography>
                                        <Typography variant="body2" style={{ userSelect: 'none' }}>
                                            {t('orderDetail.email')} ornek@lcwaikiki.com
                                        </Typography>
                                    </div>
                                </div>
                            </Grid>
                        )}
                    </CardContent>
                </Card>
            </Grid>
        </>
    );
}

export default CustomerInformationCard;
